import React, { useState, useContext, Fragment } from 'react';
import htmr from 'htmr';
function Text(props) {


    return (
        <div className="flexcolumn displayflex flex1 quiz-container">
            <div style={{ fontSize: 16 }}>
                {htmr(props.data.question)}
            </div>
        </div>
    );
}

export default Text;